import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/common'

/** 上传文件 */
export const uploadFile = (params) => {
  return axios.post(`${rootApi}/uploadFile`, params, {dataType: 'file'})
}

/** 旋转图片 */
export const rotateImg = (params) => {
  return axios.post(`${rootApi}/rotateImg`, params)
}
